import { render, staticRenderFns } from "./OrderLists.vue?vue&type=template&id=00c22812&scoped=true"
import script from "./OrderLists.vue?vue&type=script&lang=js"
export * from "./OrderLists.vue?vue&type=script&lang=js"
import style0 from "./OrderLists.vue?vue&type=style&index=0&id=00c22812&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c22812",
  null
  
)

export default component.exports